import React from 'react';
import style from './index.module.css';

type Props = {
    onChange?: () => void;
    label?: string;
    checked?: boolean;
    name: string;
    disabled?: boolean;
};

const Radio = ({ label, checked, onChange, name, disabled }: Props) => (
    <label className={`${style.label} ${disabled ? style.disabled : ''}`}>
        {label}
        <input
            className={style.radioInput}
            type="radio"
            name={name}
            onChange={onChange}
            checked={checked}
            disabled={disabled}
        />
        <span className={style.checkmark}></span>
    </label>
);
export default Radio;
